import React from "react";
import "./Loader.css";

const Loader = () => {
  return (
    <div className="loader-container">
      <h1 className="loader-text">
        {"ETM Academy".split("").map((char, index) => (
          <span key={index} style={{ animationDelay: `${index * 0.15}s` }}>
            {char === " " ? "\u00A0" : char}
          </span>
        ))}
      </h1>
      <p className="loading-sub">Loading...</p>
    </div>
  );
};

export default Loader;
